(function () {
  const WARRIOR_ID = 55709184426353;
  const DHARWAD_ID = 55709184295281;
  const GRIP_NAMES = {};
  GRIP_NAMES[WARRIOR_ID] = 'Warrior Grip';
  GRIP_NAMES[DHARWAD_ID] = 'Dharwad Grip';

  // Guard: prevents reconcile loop when we fire cart:refresh ourselves
  var _gripRefreshPending = false;

  // Reads inventory qty/policy from Liquid-rendered data attributes and disables
  // radio inputs that can't be fulfilled. Safe to call multiple times per selector.
  function applyAvailabilityToSelector(selector) {
    // If the MAIN product is sold out, no main+grip combination is purchasable —
    // every option (including "No Grip") must be disabled, regardless of grip stock.
    // base_variant.available is false only for a genuine sell-out; pre-order
    // (continue-selling) stays available, so grips remain selectable for pre-orders.
    var baseUnavailable = selector.dataset.baseAvailable === 'false';

    var wQty = parseInt(selector.dataset.warriorQty, 10);
    var dQty = parseInt(selector.dataset.dharwadQty, 10);
    if (isNaN(wQty) || selector.dataset.warriorPolicy === 'continue') wQty = 999;
    if (isNaN(dQty) || selector.dataset.dharwadPolicy === 'continue') dQty = 999;

    selector.querySelectorAll('input[type="radio"][data-grips]').forEach(function (input) {
      if (input.dataset.availabilityChecked) return; // already processed
      input.dataset.availabilityChecked = '1';

      var canFulfill;
      if (baseUnavailable) {
        canFulfill = false;
      } else {
        const grips = JSON.parse(input.dataset.grips || '[]');
        const needsWarrior = grips.filter(function (g) { return g === WARRIOR_ID; }).length;
        const needsDharwad = grips.filter(function (g) { return g === DHARWAD_ID; }).length;
        canFulfill = (needsWarrior === 0 || wQty >= needsWarrior)
                  && (needsDharwad === 0 || dQty >= needsDharwad);
      }

      if (!canFulfill) {
        input.disabled = true;
        input.classList.add('disabled');
        // Fall back to "No Grip" only when the main product IS available (i.e. only a
        // specific grip is out of stock). If the main is sold out, No Grip is disabled too.
        if (input.checked && !baseUnavailable) {
          input.checked = false;
          const noGrip = selector.querySelector('input[type="radio"][data-grips="[]"]');
          if (noGrip) {
            noGrip.checked = true;
            const labelEl = selector.querySelector('.grip-selector__selected-label');
            if (labelEl) labelEl.textContent = 'No Grip';
          }
        }
      }
    });
  }

  function checkGripAvailability() {
    document.querySelectorAll('.grip-selector').forEach(applyAvailabilityToSelector);
  }

  // Apply availability to grip selectors injected dynamically (quick-view modals)
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('grip-selector')) {
          applyAvailabilityToSelector(node);
        } else if (node.querySelector) {
          node.querySelectorAll('.grip-selector').forEach(applyAvailabilityToSelector);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  // Update selected label text when a grip radio is changed
  document.addEventListener('change', function (e) {
    const input = e.target;
    if (!input || input.type !== 'radio' || !('grips' in input.dataset)) return;
    const selector = input.closest('.grip-selector');
    if (!selector) return;
    const labelEl = selector.querySelector('.grip-selector__selected-label');
    if (labelEl && input.dataset.gripLabel) labelEl.textContent = input.dataset.gripLabel;
  });

  // Add a variant to cart
  async function cartAdd(variantId, quantity, properties) {
    const body = { id: variantId, quantity: quantity };
    if (properties) body.properties = properties;
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
    if (!res.ok) {
      const err = await res.json().catch(function () { return {}; });
      throw new Error(err.description || 'Failed to add to cart');
    }
    return res.json();
  }

  // Gather form line-item properties (inputs named properties[...]) into an object. A native
  // form submit sends these automatically; because the grip flow builds its own /cart/add.js
  // payload we must collect them ourselves — otherwise signals like the pre-order
  // "Order Type" = "Pre-Order" hidden input (and gift-card recipient fields) get dropped.
  function collectFormProperties(form) {
    var props = null;
    form.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]').forEach(function (el) {
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      var m = el.name.match(/^properties\[(.+)\]$/);
      if (!m || el.value === '') return;
      (props = props || {})[m[1]] = el.value;
    });
    return props;
  }

  // Shared: read the selection from a grip-bundle form and add base + selected grips to cart.
  // Grips are added first so the base product (added last) appears at the top of the cart.
  // Used by BOTH the Add-to-cart submit handler and the custom Buy-it-now button so the
  // No-Grip / Any-Grip behaviour is identical for both.
  async function addGripBundleFromForm(form) {
    const idInput = form.querySelector('input[data-grip-base-id]');
    if (!idInput) throw new Error('Missing base variant');
    const baseVariantId = parseInt(idInput.dataset.gripBaseId, 10);

    const checkedInput = form.querySelector('input[type="radio"][data-grips]:checked');
    const selectedGrips = JSON.parse(checkedInput ? checkedInput.dataset.grips || '[]' : '[]');

    const qtyInput = form.querySelector('[name=quantity]')
      || form.closest('section, [id*="product"]')?.querySelector('[name=quantity]')
      || document.querySelector('.quantity__input, [name=quantity]');
    const quantity = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;

    // Guard: block if the base product OR the selected grips × quantity exceed live stock, so we
    // never push an over-order into Shopify's checkout (which would surface a confusing
    // quantity-update notice). Runs BEFORE anything is added, so no partial cart state.
    const selector = form.querySelector('.grip-selector');
    if (selector) {
      var short = [];

      // Main/base product stock
      var baseStock = parseInt(selector.dataset.baseQty, 10);
      var baseUntracked = !selector.dataset.baseTracked; // empty inventory_management = untracked
      if (baseUntracked || selector.dataset.basePolicy === 'continue' || isNaN(baseStock)) baseStock = Infinity;
      if (quantity > baseStock) {
        short.push((selector.dataset.baseName || 'this item') + ' (' + baseStock + ' in stock, need ' + quantity + ')');
      }

      // Grip stock (per-grip count × quantity)
      if (selectedGrips.length) {
        var wStock = parseInt(selector.dataset.warriorQty, 10);
        var dStock = parseInt(selector.dataset.dharwadQty, 10);
        if (isNaN(wStock) || selector.dataset.warriorPolicy === 'continue') wStock = Infinity;
        if (isNaN(dStock) || selector.dataset.dharwadPolicy === 'continue') dStock = Infinity;
        var needW = selectedGrips.filter(function (g) { return g === WARRIOR_ID; }).length * quantity;
        var needD = selectedGrips.filter(function (g) { return g === DHARWAD_ID; }).length * quantity;
        if (needW > wStock) short.push(GRIP_NAMES[WARRIOR_ID] + ' (' + wStock + ' in stock, need ' + needW + ')');
        if (needD > dStock) short.push(GRIP_NAMES[DHARWAD_ID] + ' (' + dStock + ' in stock, need ' + needD + ')');
      }

      if (short.length) {
        throw new Error('Not enough stock for this quantity: ' + short.join('; ') + '. Please lower the quantity and try again.');
      }
    }

    const wrapper = form.closest('[data-product-handle]');
    const productHandle = wrapper ? wrapper.dataset.productHandle : null;

    for (var i = 0; i < selectedGrips.length; i++) {
      var props = { _bundle_component: 'true', _grip_name: GRIP_NAMES[selectedGrips[i]] || 'Grip' };
      if (productHandle) props._parent_handle = productHandle;
      await cartAdd(selectedGrips[i], quantity, props);
    }

    // Base product carries any form-level properties (e.g. pre-order "Order Type") so the
    // cart announcement and order tagging work for grip bundles just like normal products.
    await cartAdd(baseVariantId, quantity, collectFormProperties(form));
  }

  // Remove orphaned grip items using _parent_handle to identify which grips lost their parent.
  // Falls back to "remove all grips if no non-grip items" for items without parent tracking.
  async function reconcileGrips() {
    try {
      const cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      const gripItems = cart.items.filter(function (i) {
        return i.properties && i.properties._bundle_component === 'true';
      });
      if (!gripItems.length) return;

      const updates = {};

      gripItems.forEach(function (grip) {
        const parentHandle = grip.properties._parent_handle;
        if (parentHandle) {
          const parentExists = cart.items.some(function (i) {
            return i.handle === parentHandle
              && !(i.properties && i.properties._bundle_component === 'true');
          });
          if (!parentExists) updates[grip.key] = 0;
        } else {
          const hasNonGrip = cart.items.some(function (i) {
            return !(i.properties && i.properties._bundle_component === 'true');
          });
          if (!hasNonGrip) updates[grip.key] = 0;
        }
      });

      if (!Object.keys(updates).length) return;

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
      _gripRefreshPending = true;
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
      setTimeout(function () { _gripRefreshPending = false; }, 500);
    } catch (err) {
      console.warn('[grip-selector] reconciliation failed:', err);
    }
  }

  // Intercept theme fetch calls to /cart/change.js to trigger reconciliation
  // (fires when user clicks Remove in cart drawer)
  var _origFetch = window.fetch;
  window.fetch = function (url) {
    var result = _origFetch.apply(this, arguments);
    var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
    if (urlStr.indexOf('/cart/change') !== -1 && !_gripRefreshPending) {
      result.then(function (res) {
        if (res.ok) setTimeout(reconcileGrips, 400);
        return res;
      });
    }
    return result;
  };

  // Form submit — intercept add-to-cart for grip-bundle products
  document.addEventListener('submit', async function (e) {
    const form = e.target.closest
      ? e.target.closest('form[data-type="add-to-cart-form"]')
      : null;
    if (!form) return;

    const idInput = form.querySelector('input[data-grip-base-id]');
    if (!idInput) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const submitBtn = form.querySelector('button[type="submit"][name="add"]');
    const btnTextEl = submitBtn ? submitBtn.querySelector('.btn-text span') : null;
    const originalBtnText = btnTextEl ? btnTextEl.textContent : null;
    const errorDiv = form.querySelector('.product-form__error-message');

    if (submitBtn) submitBtn.disabled = true;
    if (btnTextEl) btnTextEl.textContent = 'Adding…';
    if (errorDiv) errorDiv.setAttribute('hidden', '');

    try {
      await addGripBundleFromForm(form);
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));

    } catch (err) {
      console.error('[grip-selector] add to cart failed:', err);
      if (errorDiv) {
        errorDiv.textContent = err.message || 'Something went wrong. Please try again.';
        errorDiv.removeAttribute('hidden');
        setTimeout(function () { errorDiv.setAttribute('hidden', ''); }, 5000);
      }
    } finally {
      if (submitBtn) submitBtn.disabled = false;
      if (btnTextEl && originalBtnText) btnTextEl.textContent = originalBtnText;
    }

  }, true);

  // Custom "Buy it now" for grip bundles. The native dynamic-checkout (wallet) button can
  // only check out the form's single variant, so it can't carry grip line items. This runs
  // the SAME add-to-cart flow as the submit handler, then redirects to checkout.
  document.addEventListener('click', function (e) {
    const btn = e.target.closest ? e.target.closest('[data-grip-buy-now]') : null;
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const formId = btn.getAttribute('form');
    const form = (formId && document.getElementById(formId))
      || btn.closest('form[data-type="add-to-cart-form"]')
      || (btn.closest('[data-grip-bundle]') && btn.closest('[data-grip-bundle]').querySelector('form[data-type="add-to-cart-form"]'));
    if (!form) return;

    // Add base + grips to the cart, then redirect to checkout. When gated, TermsGate has already
    // recorded the acceptance proof onto the cart before this runs.
    const proceed = async function () {
      const textEl = btn.querySelector('.btn-text');
      const originalText = textEl ? textEl.textContent : null;
      const errorDiv = form.querySelector('.product-form__error-message');

      btn.disabled = true;
      if (textEl) textEl.textContent = 'Processing…';
      if (errorDiv) errorDiv.setAttribute('hidden', '');

      try {
        await addGripBundleFromForm(form);
        // Everything (base + grips) is now in the cart — go straight to checkout.
        window.location.href = '/checkout';
      } catch (err) {
        console.error('[grip-selector] buy now failed:', err);
        btn.disabled = false;
        if (textEl && originalText) textEl.textContent = originalText;
        if (errorDiv) {
          errorDiv.textContent = err.message || 'Something went wrong. Please try again.';
          errorDiv.removeAttribute('hidden');
          setTimeout(function () { errorDiv.setAttribute('hidden', ''); }, 5000);
        }
      }
    };

    // Gate behind the Terms agree-popup when available; otherwise proceed directly.
    if (window.TermsGate && document.querySelector('terms-modal')) {
      window.TermsGate.require(function () { proceed(); });
    } else {
      proceed();
    }
  }, true);

  // Event-based reconciliation (fallback for themes using cart:updated)
  document.addEventListener('cart:updated', reconcileGrips);
  document.addEventListener('cart:refresh', function () {
    if (_gripRefreshPending) return;
    setTimeout(reconcileGrips, 300);
  });

  // Init
  checkGripAvailability();
  // On page load: clean up orphaned grips and reload if needed
  setTimeout(async function () {
    try {
      const cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      const gripItems = cart.items.filter(function (i) {
        return i.properties && i.properties._bundle_component === 'true';
      });
      if (!gripItems.length) return;

      const updates = {};
      gripItems.forEach(function (grip) {
        const parentHandle = grip.properties._parent_handle;
        if (parentHandle) {
          const parentExists = cart.items.some(function (i) {
            return i.handle === parentHandle
              && !(i.properties && i.properties._bundle_component === 'true');
          });
          if (!parentExists) updates[grip.key] = 0;
        } else {
          const hasNonGrip = cart.items.some(function (i) {
            return !(i.properties && i.properties._bundle_component === 'true');
          });
          if (!hasNonGrip) updates[grip.key] = 0;
        }
      });

      if (!Object.keys(updates).length) return;

      await _origFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
      window.location.reload();
    } catch (err) {
      console.warn('[grip-selector] init reconcile failed:', err);
    }
  }, 500);
})();
